import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import { Switch } from '@/components/ui/switch';
import { Mail, Send, Save, CheckCircle2, XCircle } from 'lucide-react';

export function SmtpConfigCard({ 
  smtpConfig, 
  setSmtpConfig, 
  onSave, 
  onTest, 
  saving, 
  testingSmtp 
}) {
  return (
    <Card className="border-border bg-card">
      <CardHeader>
        <div className="flex items-center justify-between">
          <div>
            <CardTitle className="text-lg flex items-center gap-2" style={{ fontFamily: 'Manrope' }}>
              <Mail className="w-5 h-5 text-green-500" />
              Configurazione Email SMTP
              {smtpConfig.configured ? (
                <span className="ml-2 flex items-center text-xs text-green-500">
                  <CheckCircle2 className="w-3 h-3 mr-1" /> Configurato
                </span>
              ) : (
                <span className="ml-2 flex items-center text-xs text-yellow-500">
                  <XCircle className="w-3 h-3 mr-1" /> Non configurato
                </span>
              )}
            </CardTitle>
            <CardDescription>
              Configura il server SMTP per l'invio delle email (OTP, reset password, notifiche)
            </CardDescription>
          </div>
        </div>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label>Host SMTP *</Label>
            <Input
              data-testid="smtp-host"
              placeholder="smtp.gmail.com"
              value={smtpConfig.smtp_host}
              onChange={(e) => setSmtpConfig({ ...smtpConfig, smtp_host: e.target.value })}
            />
          </div>
          <div className="space-y-2">
            <Label>Porta</Label>
            <Input
              data-testid="smtp-port"
              type="number"
              value={smtpConfig.smtp_port}
              onChange={(e) => setSmtpConfig({ ...smtpConfig, smtp_port: parseInt(e.target.value) || 587 })}
            />
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label>Username SMTP *</Label>
            <Input
              data-testid="smtp-user"
              placeholder="email@dominio.com"
              value={smtpConfig.smtp_user}
              onChange={(e) => setSmtpConfig({ ...smtpConfig, smtp_user: e.target.value })}
            />
          </div>
          <div className="space-y-2">
            <Label>Password SMTP *</Label>
            <Input
              data-testid="smtp-password"
              type="password"
              placeholder={smtpConfig.smtp_password_set ? '••••••••' : 'Password o App Password'}
              value={smtpConfig.smtp_password === '********' ? '' : smtpConfig.smtp_password}
              onChange={(e) => setSmtpConfig({ ...smtpConfig, smtp_password: e.target.value })}
            />
            <p className="text-xs text-muted-foreground">
              Per Gmail usa una "App Password" (non la password normale)
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label>Email Mittente *</Label>
            <Input
              data-testid="smtp-from-email"
              placeholder="noreply@dominio.com"
              value={smtpConfig.smtp_from_email}
              onChange={(e) => setSmtpConfig({ ...smtpConfig, smtp_from_email: e.target.value })}
            />
          </div>
          <div className="space-y-2">
            <Label>Nome Mittente</Label>
            <Input
              data-testid="smtp-from-name"
              placeholder="OBC Cloud"
              value={smtpConfig.smtp_from_name}
              onChange={(e) => setSmtpConfig({ ...smtpConfig, smtp_from_name: e.target.value })}
            />
          </div>
        </div>

        <div className="flex items-center gap-3">
          <Switch
            id="smtp-tls"
            checked={smtpConfig.smtp_use_tls}
            onCheckedChange={(checked) => setSmtpConfig({ ...smtpConfig, smtp_use_tls: checked })}
            data-testid="smtp-use-tls"
          />
          <Label htmlFor="smtp-tls" className="cursor-pointer">
            Usa TLS/STARTTLS (consigliato per porta 587)
          </Label>
        </div>

        <Separator />

        <div className="flex flex-wrap gap-3">
          <Button
            onClick={onSave}
            disabled={saving}
            data-testid="save-smtp-config"
            className="bg-primary text-primary-foreground hover:bg-primary/90"
          >
            <Save className="w-4 h-4 mr-2" />
            {saving ? 'Salvataggio...' : 'Salva Configurazione SMTP'}
          </Button>
          {smtpConfig.configured && (
            <Button
              variant="outline"
              onClick={onTest}
              disabled={testingSmtp}
              data-testid="test-smtp"
            >
              <Send className="w-4 h-4 mr-2" />
              {testingSmtp ? 'Invio test...' : 'Invia Email di Test'}
            </Button>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
